export const getBathroomCount = ({
  fullBathroomCount = 0,
  halfBathroomCount = 0,
  quarterBathroomCount = 0,
  threeQuarterBathroomCount = 0,
}) =>
  fullBathroomCount +
  threeQuarterBathroomCount +
  0.5 * halfBathroomCount +
  0.25 * quarterBathroomCount;
